import { useDispatch } from 'react-redux';

import { SystemsAPI } from '../api/systems.api';

import { decorateSystem } from '../redux-store/reducers/systems.reducer';
import { setInternalSystems } from '../redux-store/reducers/internalPipes.reducer';
import { getInternalDataEntities } from '../utils/commonDataEntities.utils';

import type { System } from '../types/system.types';

export const useLoadInternalSystems = (subUrl: string, token: string) => {
  const dispatch = useDispatch();

  const loadInternalSystems = async () => {
    if (!token) {
      return;
    }

    SystemsAPI.getAll(
      {
        subUrl,
        token,
      },
      true
    ).then((allSystems) => {
      const filtered = getInternalDataEntities<System>(allSystems).map((s) => decorateSystem(s));

      dispatch(setInternalSystems(filtered));
    });
  };

  return { loadInternalSystems };
};
